var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 7.5,
  viewBox: "0 0 15 7.5"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -137.052)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.913,140.549,11.58,137.13a.255.255,0,0,0-.3-.049.286.286,0,0,0-.165.283v2.188H.278a.255.255,0,0,0-.2.088.326.326,0,0,0-.078.225v1.875a.325.325,0,0,0,.078.224.255.255,0,0,0,.2.088H11.111v2.188a.3.3,0,0,0,.165.283.249.249,0,0,0,.3-.058l3.333-3.458a.34.34,0,0,0,.087-.234A.328.328,0,0,0,14.913,140.549Z",
  transform: "translate(0)",
  fill: "currentColor"
}))));
export default __webpack_public_path__ + "static/media/long-arrow.bb8bae85.svg";
export { SvgComponent as ReactComponent };